<template>
  <div id="questionnaire" v-if="divVisible">
    <b>評価実施画面</b><br/><br/>

    <table class="table icon">
      <tr>
        <td>評価実施のご協力をお願いいたします。</td>
      </tr>
    </table><br/>

    <form onsubmit="return false;">

      <div align="right">
        評価待ち情報{{rows.length}}件
        <button v-if="!showFlg" @click="showFlg = !showFlg;">↓</button>
        <button v-if=" showFlg" @click="showFlg = !showFlg;">↑</button>
      </div>
      <div v-if="showFlg" class="bootstrap-table fixed-table-container" style="margin-bottom:10px;margin-bottom:10px;width: 100%;">
        <table id="rptHeader2" class="table table-striped">
          <thead>
            <tr>
              <td><b>被評価プロジェクト</b></td>
              <td><b>被評価者</b></td>
              <td><b>評価期間</b></td>
              <td><b>評価</b></td>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(row, index4) in rows.slice(0,1)" v-bind:key="'row' + index4" style="background-color:#E1E1FF">
              <td><b>{{row.projectInfo.projectName}}</b></td>
              <td><b>{{row.evaluateeMemberInfo.memberName}}</b></td>
              <td>
                <b v-for="(rowOptionYearMonth, index5) in row.optionYearMonths" v-bind:key="'rowOptionYearMonth' + index5">
                  {{ rowOptionYearMonth.text }}
                </b>
              </td>
              <td></td>
            </tr>
            <tr v-for="(row, index4) in rows.slice(1)" v-bind:key="'row' + index4" style="background-color:#E1E1FF">
              <td>{{row.projectInfo.projectName}}</td>
              <td>{{row.evaluateeMemberInfo.memberName}}</td>
              <td>
                <font v-for="(rowOptionYearMonth, index5) in row.optionYearMonths" v-bind:key="'rowOptionYearMonth' + index5">
                  {{ rowOptionYearMonth.text }}
                </font>
              </td>
              <td>
                <a hlef="#" @click="questionnaireClick(row.evaluateeMemberInfo.memberID, row.projectInfo.projectID);">評価</a>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="bootstrap-table fixed-table-container" style="margin-bottom:10px;margin-bottom:10px;width: 100%;">
        <table id="rptHeader0" class="table table-striped">
          <tbody>
            <tr>
              <td><b>被評価者：</b></td>
              <td style="font-size: 150%;letter-spacing:5px;">{{ rows[0].evaluateeMemberInfo.memberName }}</td>
            </tr>
            <tr>
              <td><b>被評価プロジェクト：</b></td>
              <td>{{ rows[0].projectInfo.projectName }} ({{ rows[0].projectInfo.startDate + " ～ " +  rows[0].projectInfo.endDate }})</td>
            </tr>
            <tr>
              <td><b>評価期間：</b></td>
              <td>
                <label v-for="(rowOptionYearMonth, index2) in rows[0].optionYearMonths" v-bind:key="'rowOptionYearMonth' + index2">
                  <input type="checkbox"
                    v-model="rowOptionYearMonth.selected"
                    v-bind:value="rowOptionYearMonth.value">{{ rowOptionYearMonth.text }}&nbsp;&nbsp;
                </label><br/><span style="font-size: 80%">
                上記チェックした期間内{{ rows[0].evaluateeMemberInfo.memberName }}さんの作業状況評価できない場合のみ、
               <a href="#" id="skipLink"  @click.prevent="skipClick();">ここ</a>を押下して評価スキップ申請してください。</span><br/>
              </td>
            </tr>
          </tbody>
        </table><br/><br/>

        <table id="rptHeader1" class="table table-striped">
          <thead>
            <tr>
              <td style="width: 10%;"><b>番号</b></td>
              <td style="width: 40%;"><b>評価項目名</b></td>
              <td style="width: 50%;"><b>評価値</b></td>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(rowQuestionnaireAndAnswer, index3) in rows[0].questionnaireAndAnswers" v-bind:key="'rowQuestionnaireAndAnswer' + index3">
              <td>{{ index3 + 1 }}</td>
              <td>{{ rowQuestionnaireAndAnswer.title }}:<br/> {{ rowQuestionnaireAndAnswer.description }}</td>
              <td>
                  <input type="radio"
                    v-if="rowQuestionnaireAndAnswer.option1Score"
                    v-model="rowQuestionnaireAndAnswer.optionScore"
                    v-bind:value="rowQuestionnaireAndAnswer.option1Score"
                    ><font v-if="rowQuestionnaireAndAnswer.option1Score"
                    >{{ rowQuestionnaireAndAnswer.option1 }}&nbsp;<br/></font>
                  <input type="radio"
                    v-if="rowQuestionnaireAndAnswer.option2Score"
                    v-model="rowQuestionnaireAndAnswer.optionScore"
                    v-bind:value="rowQuestionnaireAndAnswer.option2Score"
                    ><font v-if="rowQuestionnaireAndAnswer.option2Score"
                    >{{ rowQuestionnaireAndAnswer.option2 }}&nbsp;<br/></font>
                  <input type="radio"
                    v-if="rowQuestionnaireAndAnswer.option3Score"
                    v-model="rowQuestionnaireAndAnswer.optionScore"
                    v-bind:value="rowQuestionnaireAndAnswer.option3Score"
                    ><font v-if="rowQuestionnaireAndAnswer.option3Score"
                    >{{ rowQuestionnaireAndAnswer.option3 }}&nbsp;<br/></font>
                  <input type="radio"
                    v-if="rowQuestionnaireAndAnswer.option4Score"
                    v-model="rowQuestionnaireAndAnswer.optionScore"
                    v-bind:value="rowQuestionnaireAndAnswer.option4Score"
                    ><font v-if="rowQuestionnaireAndAnswer.option4Score"
                    >{{ rowQuestionnaireAndAnswer.option4 }}&nbsp;<br/></font>
                  <input type="radio"
                    v-if="rowQuestionnaireAndAnswer.option5Score"
                    v-model="rowQuestionnaireAndAnswer.optionScore"
                    v-bind:value="rowQuestionnaireAndAnswer.option5Score"
                    ><font v-if="rowQuestionnaireAndAnswer.option5Score"
                    >{{ rowQuestionnaireAndAnswer.option5 }}&nbsp;<br/></font>
                  <input type="radio"
                    v-if="rowQuestionnaireAndAnswer.option6Score"
                    v-model="rowQuestionnaireAndAnswer.optionScore"
                    v-bind:value="rowQuestionnaireAndAnswer.option6Score"
                    ><font v-if="rowQuestionnaireAndAnswer.option6Score"
                    >{{ rowQuestionnaireAndAnswer.option6 }}&nbsp;<br/></font>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <center class="msg-error" style="display:block;"><img src="/static/images/warning.png" width="20" height="20" class="img-btn">確定した評価<b>再修正できません</b>！</center>
      <button id="saveBtn" v-on:click="saveClick" class="btn-mid" style="width:250px;">{{ rows[0].evaluateeMemberInfo.memberName }}さんの評価を確定し<br>次の方の評価を実施</button>&nbsp;
　    <button v-if="$route.params.backScreenId == 'mains'" @click="$router.push({ name: 'mains', params: { } });" class="btn-mid" style="width:250px;">メイン画面へ</button><br/>
      <button v-if="$route.params.backScreenId == 'questionnaireAnswer'" @click="$router.push({ name: 'questionnaireAnswer', params: { } });" class="btn-mid" style="width:250px;">評価結果一覧画面へ</button><br/>
    </form>
  </div>
</template>

<script>
  export default {
    name: "questionnaire",
    data() {
      return {
          divVisible: false,
          showFlg: false,
          user:  { memberID: '', memberName: '', userType: '', deleteFlg: '' },
          // heads: [ ],
          rows:  [ { projectInfo: { projectID: '', projectName: '', startDate: '', endDate: '' },
                     evaluateeMemberInfo: { memberID: '', memberName: '' },
                     appraiserMemberInfo: { memberID: '', memberName: '' },
                     optionYearMonths: [ { value: '', text: '', selected: true }, ],
                     questionnaireAndAnswers: [ { questionnaireID: '', description: '',
                                                  option1: '', option1Score: '', option2: '', option2Score: '', option3: '', option3Score: '',
                                                  option4: '', option4Score: '', option5: '', option5Score: '', option6: '', option6Score: '',
                                                  title: '', option: '', optionScore: '' }, ], },
                 ],
      }
    },
    mounted() {
      const s = document.createElement('script');
      s.type = 'text/javascript';
      s.src = '/static/js/common.js?v=17';
      document.body.appendChild(s);
      this.init();
    },
    methods: {
      init: function () {
        var self = this;

        // サーバ側処理呼び出す
        new Promise(function (request, response) {
          var data = self.$route.params;
          common.getAxios().post(process.env.API_URL +"/api/QuestionnaireInit", data)
            .then(function (res) {
              if (res.data && res.data.rows.length > 0) {
                self.user = res.data.user;
                // self.heads = res.data.heads;
                self.rows = res.data.rows;

                self.divVisible = true;
              }
              else {
                alert ("全て評価は実施済みです、実施待ち評価はありません。");
                self.$router.back(-1);
              }
            })
            .catch(function (err) {
              alert(err);
            });
        });
      },
      skipClick: function () {
        var self = this;
        var data = { rowData:JSON.stringify(self.rows[0]) };
        $("#skipLink").attr("disabled", true);
        common.getAxios().post(process.env.API_URL +"/api/QuestionnaireSkipApply", data)
          .then(function (res) {
            $("#skipLink").attr("disabled", false);
            // 処理正常の場合
            if (res.data == '') {
              alert(self.rows[0].evaluateeMemberInfo.memberName+"の評価スキップ申請提出しました。");
              if(!self.$route.params["directEvalFlg"]){
                // 次の評価実施へ
                self.init();
              }
              else{
                // 直接評価
                self.$router.back(-1);
              }
            }
            // 処理エラーの場合
            else {
              alert(res.data);
            }

          })
          .catch(function (err) {
            alert(err);
            $("#skipLink").attr("disabled", false);
          });
        return false;
      },
      saveClick: function () {
        var self = this;
        var data = { rowData:JSON.stringify(self.rows[0]) };
        $("#saveBtn").attr("disabled", true);
        common.getAxios().post(process.env.API_URL +"/api/QuestionnaireSave", data)
          .then(function (res) {
            $("#saveBtn").attr("disabled", false);
            // 処理正常の場合
            if (res.data == '') {
              if(!self.$route.params["directEvalFlg"]){
                // 次の評価実施へ
                self.init();
              }
              else{
                // 直接評価
                self.$router.back(-1);
              }
            }
            // 処理エラーの場合
            else {
              alert(res.data);
            }

          })
          .catch(function (err) {
            alert(err);
            $("#saveBtn").attr("disabled", false);
          });
        return false;
      },
      questionnaireClick: function (evaluateeMemberID, projectID) {
        var self = this;
        self.$router.push({ name: 'questionnaire',
          params: { backScreenId: self.$route.params.backScreenId, evaluateeMemberID: evaluateeMemberID, projectID: projectID } });
        this.init();
      },
    }
  };
</script>



// WEBPACK FOOTER //
// questionnaire.vue?0ed13f64